module.exports = __webpack_public_path__ + "static/media/DoorSpeakerUnlocked2.60b7a967.png";